import React, {Component} from 'react'
import SkuDetailPage from './SkuDetailPage'

class SkuDetailContainer extends Component {
    _parseSkuId = () => {
        const {skuID} = this.props.match.params

        return skuID
    }

    render() {
        const skuID = this._parseSkuId()

        return (
            <div className="SkuDetailContainer">
                <SkuDetailPage id={skuID}/>
            </div>
        )
    }
}

export default SkuDetailContainer